"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GeoLocationPickerField = void 0;
var _react = _interopRequireWildcard(require("react"));
var _alloyProvider = require("@adsk/alloy-provider");
var _accLocationsComponents = require("@adsk/acc-locations-components");
var _PagePopover = _interopRequireDefault(require("../../utils/components/PagePopover"));
var _useLocationsMapUrl = require("../../hooks/useLocationsMapUrl");
var _geoActionTracking = require("../../utils/analytics/geoActionTracking");
var _lodash = require("lodash");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const GeoLocationPickerField = _ref => {
  let {
    issue,
    onChange,
    error = false,
    htmlId = "",
    disabled = false
  } = _ref;
  const [geoValue, setGeoValue] = (0, _react.useState)((issue === null || issue === void 0 ? void 0 : issue.gpsCoordinates) || null);
  const [isIframeModalOpen, setIsIframeModalOpen] = (0, _react.useState)(false);
  const projectId = (0, _alloyProvider.useCurrentProjectId)();
  const isMapDisabled = disabled || window.location.pathname.includes("/locations");
  const displayMapUrl = (0, _useLocationsMapUrl.useLocationsMapUrl)({
    issueId: issue ? issue.id : ""
  });
  const inputMapUrl = (0, _useLocationsMapUrl.useLocationsMapUrl)(issue ? {
    issueId: issue.id,
    mode: "add"
  } : {
    mode: "place"
  });
  //Because we have an iframe with the same data in the creation form,
  //we want to make sure that only the relevant component will use the data from the event,
  //otherwise we can experience a bug in which the create form is effecting the field in the edit form.
  const isLocationPlacementMode = (0, _react.useRef)(false);
  const handleMessage = (0, _react.useCallback)(event => {
    if ((0, _lodash.isObject)(event.data) && (0, _lodash.has)(event.data, "gpsCoordinates")) {
      setIsIframeModalOpen(false);
      if (isLocationPlacementMode.current && event.data.gpsCoordinates) {
        onChange(event.data.gpsCoordinates);
        setGeoValue(event.data.gpsCoordinates);
        if (issue) {
          //Track the event only in inline mode aka when there is an issue
          (0, _geoActionTracking.trackGeoAction)(_geoActionTracking.GEO_EVENTS.COORDINATES, {
            action: _geoActionTracking.GEO_ACTIONS.SET,
            method: _geoActionTracking.GEO_SET_METHODS.PLACED_WITH_MAP
          });
        }
      }
      isLocationPlacementMode.current = false;
    }
  }, [onChange, issue]);
  const handleMapOpen = (0, _react.useCallback)(() => {
    if (issue) {
      //Track the event only in inline mode aka when there is an issue
      (0, _geoActionTracking.trackGeoAction)(_geoActionTracking.GEO_EVENTS.OPEN_MAP_VIEW, {
        origin: _geoActionTracking.GEO_OPEN_MAP_SOURCES.DETAILS
      });
    }
    if (issue && issue.gpsCoordinates) {
      window.open(displayMapUrl, "_blank", "noopener");
    } else {
      isLocationPlacementMode.current = true;
      setIsIframeModalOpen(true);
    }
  }, [displayMapUrl, issue]);
  const handleChange = (0, _react.useCallback)(value => {
    //Convert null to undefined in issue creation so we won’t send redundant data
    if (!issue && !value) {
      onChange();
      return;
    }
    if (issue) {
      //Track the event only in inline mode aka when there is an issue
      (0, _geoActionTracking.trackGeoAction)(_geoActionTracking.GEO_EVENTS.COORDINATES, {
        action: !value ? _geoActionTracking.GEO_ACTIONS.REMOVE : issue.gpsCoordinates ? _geoActionTracking.GEO_ACTIONS.EDIT : _geoActionTracking.GEO_ACTIONS.SET,
        method: _geoActionTracking.GEO_SET_METHODS.TEXT_INPUT
      });
    }
    onChange(value);
  }, [onChange, issue]);
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "GeoLocationPickerField"
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: !!issue ? {
      paddingTop: "20px"
    } : {}
  }, /*#__PURE__*/_react.default.createElement(_accLocationsComponents.GeoLocationPicker, {
    key: JSON.stringify(geoValue),
    projectId: projectId,
    defaultValue: geoValue,
    onChange: handleChange,
    onOpenMap: handleMapOpen,
    disableOpenMap: isMapDisabled,
    disabled: disabled,
    isInlineEdit: !!issue,
    error: error,
    htmlId: htmlId
  })), /*#__PURE__*/_react.default.createElement(_PagePopover.default, {
    src: inputMapUrl,
    open: isIframeModalOpen,
    onMessage: handleMessage
  }));
};
exports.GeoLocationPickerField = GeoLocationPickerField;
//# sourceMappingURL=GeoLocationPickerField.js.map